import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line
import { PrimaryButton as PrimaryButtonBase } from "components/misc/Buttons.js";

import LogoImage from "images/logo.svg";
import { ReactComponent as FacebookIcon } from "images/facebook-icon.svg";
import { ReactComponent as TwitterIcon } from "images/twitter-icon.svg";
import { ReactComponent as YoutubeIcon } from "images/youtube-icon.svg";
import { ReactComponent as InstagramIcon } from "images/instagram1.svg";
import { ReactComponent as LinkedInIcon } from "images/linkedin-icon.svg";

const Container = tw.div`relative bg-gray-300 text-gray-900 -mb-8 -mx-8 px-8 mt-32`;
const Content = tw.div`max-w-screen-xl mx-auto relative z-10`;
const SixColumns = tw.div`flex flex-wrap text-center sm:text-left justify-center sm:justify-start md:justify-between -mt-12`;

const Column = tw.div`px-4 sm:px-0 sm:w-1/4 md:w-auto mt-12`;

const ColumnHeading = tw.h5`uppercase font-bold`;

const LinkList = tw.ul`mt-6 text-sm font-medium`;
const LinkListItem = tw.li`mt-3`;
const Link = tw.a`border-b-2 border-transparent text-gray-800 hocus:border-gray-800 transition duration-300`;

const SubscribeNewsletterColumn = tw(Column)`text-center lg:text-left w-full! lg:w-auto! mt-20 lg:mt-12`;
const SubscribeNewsletterContainer = tw.div`max-w-sm mx-auto lg:mx-0 `;
const SubscribeText = tw.p`mt-2 lg:mt-6 text-sm font-medium text-gray-600`;
const SubscribeForm = tw.form`mt-4 lg:mt-6 text-sm sm:flex max-w-xs sm:max-w-none mx-auto sm:mx-0`;
const Input = tw.input`bg-gray-300 px-6 py-3 rounded sm:rounded-r-none border-2 sm:border-r-0 border-gray-400 hover:border-gray-800 focus:outline-none transition duration-300 w-full`;
const SubscribeButton = tw(PrimaryButtonBase)`mt-4 sm:mt-0 w-full sm:w-auto rounded sm:rounded-l-none px-8 py-3`;

const Divider = tw.div`mb-8 border border-gray-700 w-full`;

const ThreeColRow = tw.div`flex flex-col md:flex-row items-center justify-between`;

const LogoContainer = tw.div`flex items-center justify-center md:justify-start`;
const LogoImg = tw.img`w-20 py-4`;
const LogoText = tw.h5`ml-2 text-xl font-black tracking-wider text-gray-800`;

const CopywrightNotice = tw.p`text-center text-sm sm:text-base mt-4 md:mt-4 font-thin text-gray-800 m-auto`;

const SocialLinksContainer = tw.div`py-2 md:mt-0 flex`;
const SocialLink = styled.a`
  ${tw`cursor-pointer p-2 rounded-full bg-gray-900 text-gray-100 hover:bg-gray-700 transition duration-300 mr-4 last:mr-0`}
  svg {
    ${tw`w-4 h-4`}
  }
`;

export default () => {
  return (
    <Container>
      <Content>
        <SixColumns>
          {/* <Column>
            <ColumnHeading>e-Cenówki</ColumnHeading>
            <LinkList>
              <LinkListItem>
                <Link href="#OpisRozwiazania">Opis rozwiązania</Link>
              </LinkListItem>
              <LinkListItem>
                <Link href="#CentrumPomocy">Centrum pomocy</Link>
              </LinkListItem>
              <LinkListItem>
                <Link href="#PolitykaPrywatnosci">Polityka prywatności</Link>
              </LinkListItem>
              <LinkListItem>
                <Link href="#Rodo">Klauzula Rodo</Link>
              </LinkListItem>
              <LinkListItem>
                <Link href="#PolitykaCookies">Polityka cookies</Link>
              </LinkListItem>
              <LinkListItem>
                <Link href="http://manager.e-cenowki.pl">Zaloguj się</Link>
              </LinkListItem>
            </LinkList>
          </Column> */}
          {/* <Column>
            <ColumnHeading>DATAGRIT</ColumnHeading>
            <LinkList>
              <LinkListItem>
                <Link href="http://datagrit.pl">Odwiedź naszą stronę</Link>
              </LinkListItem>
              <LinkListItem>
                <Link href="#Kariera">Dołącz do naszego Zespołu</Link>
              </LinkListItem>
              <LinkListItem>
                <Link href="#Kontakt">Skontaktuj się z nami</Link>
              </LinkListItem>
              <LinkListItem>
                <Link href="#PolitykaPrywatnosci">Polityka prywatności</Link>
              </LinkListItem>
            </LinkList>
          </Column> */}
          {/* <Column>
            <ColumnHeading>Branże</ColumnHeading>
            <LinkList>
              <LinkListItem>
                <Link href="#BranzaFarmaceutyczna">Apteki i drogerie</Link>
              </LinkListItem>
              <LinkListItem>
                <Link href="#InteligentneBiura">Biura</Link>
              </LinkListItem>
              <LinkListItem>
                <Link href="#BranzaDetaliczna">Sklepy</Link>
              </LinkListItem>
              <LinkListItem>
                <Link href="#InteligentneMagazyny">Magazyny</Link>
              </LinkListItem> 
            </LinkList>
          </Column> */}
          {/* <Column> */}
            {/* <ColumnHeading>Zasady współpracy</ColumnHeading>
            <LinkList>
              <LinkListItem>
                <Link href="/PolitykaPrywatnosci">Polityka prywatności</Link>
              </LinkListItem>
              <LinkListItem>
                <Link href="/RegulaminSerwisu">Regulamin serwisu</Link>
              </LinkListItem>
              <LinkListItem>
                <Link href="/Rodo">RODO</Link>
              </LinkListItem> */}
              {/* <LinkListItem>
                <Link href="#">Disclaimer</Link>
              </LinkListItem> */}
            {/* </LinkList> */}
          {/* </Column> */}
          {/* <SubscribeNewsletterColumn>
            <SubscribeNewsletterContainer>
              <ColumnHeading>Newsletter</ColumnHeading>
              <SubscribeText>
                Wysłyłamy ciekawe artykuły ze świata technologii, które mogą Cię zainteresować. Nie spamujemy.
              </SubscribeText>
              <SubscribeForm method="get" action="#">
                <Input type="email" placeholder="Twój adres e-mail" />
                <SubscribeButton type="submit">Wyślij</SubscribeButton>
              </SubscribeForm>
            </SubscribeNewsletterContainer>
          </SubscribeNewsletterColumn> */}
        </SixColumns>
        {/* <Divider /> */}
        <ThreeColRow>
          <LogoContainer>
            <LogoImg src="logotyp.png"/>
           <LogoText></LogoText>
          </LogoContainer>
          
          <Link href="/PolitykaPrywatnosci">Polityka prywatności</Link>
          <Link href="#Rodo">Klauzula Rodo</Link>
          <Link href="#PolitykaCookies">Polityka cookies</Link>
          <Link href="http://datagrit.pl">Odwiedź stronę Datagrit.pl</Link>
          <Link href="#Kontakt">Skontaktuj się z nami</Link>
          {/* <CopywrightNotice>&copy; Copyright 2024 All Rights Reserved.</CopywrightNotice> */}
          <SocialLinksContainer>
            
            <SocialLink href="https://www.linkedin.com/company/e-cenowki">
              <LinkedInIcon />
            </SocialLink>
            {/* <SocialLink href="https://twitter.com">
              <TwitterIcon />
            </SocialLink> */}
            <SocialLink href="https://www.youtube.com/@e-cenowki">
              <YoutubeIcon />
            </SocialLink>
          </SocialLinksContainer>
        </ThreeColRow>
      </Content>
      <CopywrightNotice>&copy; Copyright 2026 DATAGRIT Sp. z o.o. All Rights Reserved.</CopywrightNotice>
      {/* <CopywrightNotice>Skontaktuj się z nami: kontakt@e-cenowki.pl</CopywrightNotice> */}
    </Container>
  );
};
